<template>
  <section>
    <div class="bg-lifeboost-red-lighter">
      <div class="max-w-screen-2xl w-full mx-auto px-5 lg:px-14 xl:px-20 2xl:px-12 py-12 xl:py-14 2xl:py-20 relative overflow-hidden">
        <div class="flex flex-wrap items-center">
          <div class="w-full md:w-1/2 xl:w-5/12 md:pl-10 xl:pr-28 space-y-3.5 lg:space-y-5 pb-7 md:pb-0 text-center">
            <h2 class="text-3xl md:text-4xl xl:text-6xl font-ww-medium font-extrabold font-ww-medium" v-html="sectionTitle"></h2>
            <div class="text-base md:text-lg lg:text-2xl text-gray-500 font-open-sans" v-html="sectionText"></div>
          </div>
          <div class="w-full md:w-1/2 xl:w-7/12 md:pl-10">
            <div id="" class="lazy__container aspect-auto">
              <nuxt-img :src="imageSrc" :alt="imageAlt" loading="lazy" format="webp" sizes="xs:295px sm:440px md:600px lg:231px xl:400px 2xl:800px" class="object-contain w-full" style=""/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

const props = defineProps({
  sectionTitle: {
    type: String,
    default: 'A Healthier You and a Healthier World'
  },
  sectionText: {
    type: String,
    default: 'Conventional coffee is loaded with toxins, harms the environment, and hurts local communities. We’re here to deliver the healthiest, cleanest coffee that boosts your life and the world.'
  },
  imageSrc: {
    type: String,
    default: '/assets/images/contentImage1.jpg'
  },
  imageAlt: {
    type: String,
    default: ''
  },
});

defineBuilderComponent({
    friendlyName: "ContentTextImage",
    inputs: [
        {
            name: "sectionTitle",
            type: "richText",
            defaultValue: "A Healthier You and a Healthier World"
        },
        {
            name: "sectionText",
            type: "richText",
            defaultValue: "Conventional coffee is loaded with toxins, harms the environment, and hurts local communities. We’re here to deliver the healthiest, cleanest coffee that boosts your life and the world."
        },
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/contentImage1.jpg"
        },
        {
            name: "imageAlt",
            type: "string",
            defaultValue: "image"
        }
    ]
});
</script>
